import { DialogEmailComplete } from '@/components/Campaign/mynavi/MyNaviDialogs/DialogEmailComplete'
import { DialogEmailInput } from '@/components/Campaign/mynavi/MyNaviDialogs/DialogEmailInput'
import { DialogEmailRegistrationPrompt } from '@/components/Campaign/mynavi/MyNaviDialogs/DialogEmailRegistrationPrompt'
import { DialogEmailVerification } from '@/components/Campaign/mynavi/MyNaviDialogs/DialogEmailVerification'

type EmailRegistrationDialogsProps = {
  isEmailRegistrationPromptOpen: boolean
  isEmailInputOpen: boolean
  isEmailSending: boolean
  isEmailVerificationOpen: boolean
  isEmailVerifying: boolean
  isEmailResending: boolean
  isEmailCompleteOpen: boolean
  emailRegistrationError: string | null
  isEmailChangeMode?: boolean
  onRegister: () => void
  onSkip: () => void
  onEmailSubmit: (email: string) => void
  onEmailCancel: () => void
  onCodeSubmit: (code: string) => void
  onCodeResend: () => void
  onCodeBack: () => void
  onComplete: () => void
}

export const EmailRegistrationDialogs = ({
  isEmailRegistrationPromptOpen,
  isEmailInputOpen,
  isEmailSending,
  isEmailVerificationOpen,
  isEmailVerifying,
  isEmailResending,
  isEmailCompleteOpen,
  emailRegistrationError,
  isEmailChangeMode = false,
  onRegister,
  onSkip,
  onEmailSubmit,
  onEmailCancel,
  onCodeSubmit,
  onCodeResend,
  onCodeBack,
  onComplete,
}: EmailRegistrationDialogsProps) => {
  return (
    <>
      <DialogEmailRegistrationPrompt opened={isEmailRegistrationPromptOpen} onRegister={onRegister} onSkip={onSkip} />
      <DialogEmailInput
        opened={isEmailInputOpen || isEmailSending}
        isLoading={isEmailSending}
        errorMessage={emailRegistrationError}
        title={isEmailChangeMode ? 'メールアドレス変更' : 'メールアドレス登録'}
        onSubmit={onEmailSubmit}
        onCancel={onEmailCancel}
      />
      <DialogEmailVerification
        opened={isEmailVerificationOpen || isEmailVerifying || isEmailResending}
        isLoading={isEmailVerifying}
        isResending={isEmailResending}
        errorMessage={emailRegistrationError}
        onSubmit={onCodeSubmit}
        onResend={onCodeResend}
        onBack={onCodeBack}
      />
      <DialogEmailComplete opened={isEmailCompleteOpen} onClose={onComplete} />
    </>
  )
}
